import React, { useState, useMemo } from 'react';
import MonthCalendar from './MonthCalendar';
import { ContentPreview, FORMATO_COLOR, formatoColor, hhmm } from './content';

/**
 * Calendario editoriale (PED + PED Storie), costruito sul calendario condiviso.
 * - Click su un contenuto → anteprima (media, stato, "Apri contenuto").
 * - Drag&drop tra i giorni su desktop (se onMove).
 * - Modalità selezione (selectMode): il click seleziona i contenuti pubblicabili.
 */
export default function PedCalendario({ month, righe, onOpen, onMove, onNew, selectMode, selected, toggleSel, isPublishable }) {
  const [preview, setPreview] = useState(null);

  const items = useMemo(() => righe
    .filter(r => r.data_pubblicazione)
    .map(r => {
      const selectable = selectMode && isPublishable && isPublishable(r);
      return {
        id: r.id,
        date: String(r.data_pubblicazione).slice(0, 10),
        time: hhmm(r.ora_pubblicazione),
        title: r.titolo_post || r.id_post || 'Contenuto',
        sub: [r.formato, r.id_post].filter(Boolean).join(' · '),
        color: formatoColor(r.formato),
        selected: !!(selected && selected.has(r.id)),
        dimmed: selectMode && !selectable,
        draggable: !selectMode,
        raw: r,
      };
    }), [righe, selectMode, selected, isPublishable]);

  const onItemClick = (it) => {
    if (selectMode) {
      if (isPublishable && isPublishable(it.raw)) toggleSel(it.id);
      return;
    }
    setPreview(it.raw);
  };

  const legend = useMemo(() => {
    const presenti = new Set(righe.map(r => r.formato));
    return Object.entries(FORMATO_COLOR).filter(([f]) => presenti.has(f)).map(([label, color]) => ({ label, color }));
  }, [righe]);

  return (
    <>
      <MonthCalendar month={month} items={items} onItemClick={onItemClick}
        onAdd={onNew} onMove={onMove && !selectMode ? (it, ds) => onMove(it.raw, ds) : undefined}
        addLabel="Nuovo contenuto" legend={legend.length ? legend : undefined} />
      <ContentPreview r={preview} onClose={() => setPreview(null)}
        onOpen={(r) => { setPreview(null); onOpen(r); }} />
    </>
  );
}
